import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { VALET, FONTS, TYPE } from '../../theme';

const Card = styled(Box)({
  backgroundColor: VALET.surface,
  borderRadius: '14px',
  padding: '20px 22px',
  border: `1px solid ${VALET.border}`,
  boxShadow: VALET.shadow,
  '@media (max-width: 768px)': {
    padding: '14px 14px',
  },
  transition: 'border-color 200ms ease, box-shadow 200ms ease, transform 200ms ease',
  '&:hover': {
    borderColor: VALET.bronzeHairline,
    boxShadow: VALET.shadowHover,
    transform: 'translateY(-1px)',
  },
});

const Label = styled(Typography)({
  ...TYPE.kpiLabel,
  marginBottom: '12px',
});

const Value = styled(Typography)({
  ...TYPE.kpiValue,
});

const ValueSuffix = styled('span')({
  fontFamily: FONTS.sans,
  fontSize: '14px',
  fontWeight: 500,
  color: VALET.textMuted,
  marginLeft: '4px',
  letterSpacing: 0,
});

const SUB_COLORS = {
  pos: VALET.success,
  neg: VALET.danger,
  neu: VALET.textMuted,
};

const Subtitle = styled(Typography)(({ subcolor }) => ({
  fontFamily: FONTS.sans,
  fontSize: '12px',
  fontWeight: 500,
  marginTop: '8px',
  color: SUB_COLORS[subcolor] || SUB_COLORS.neu,
}));

export default function KpiCard({ label, value, suffix, subtitle, subtitleColor = 'neu' }) {
  return (
    <Card>
      <Label>{label}</Label>
      <Value>
        {value}
        {suffix && <ValueSuffix>{suffix}</ValueSuffix>}
      </Value>
      {subtitle && <Subtitle subcolor={subtitleColor}>{subtitle}</Subtitle>}
    </Card>
  );
}
